import {
  getAirQualityCategoryLabel,
  getAirQualityCategoryColor,
} from 'features/Weather/features/Forecast/features/AirQuality/config/airQuality.config';
import { PiWavesBold } from 'react-icons/pi';
import { getAirQualityReportColumnClassName } from '../../utils/airQualityWidget.utils';

const AirQualityReportList = ({ reports = [], layout }) => {
  if (!reports.length) {
    return (
      <p className="air-quality-widget-empty p-3 mb-0" role="status">
        No air quality reports found.
      </p>
    );
  }

  return (
    <ul
      className={`air-quality-report-list row ${getAirQualityReportColumnClassName(
        layout,
      )} g-3 list-unstyled mb-0`}
      aria-label="Air quality reports"
    >
      {reports.map((report) => {
        const categoryLabel = getAirQualityCategoryLabel(report.category);
        const categoryColor =
          getAirQualityCategoryColor(report.category) || 'var(--color-secondary)';

        return (
          <li className="air-quality-report-list-item col" key={report.id}>
            <article
              className="air-quality-report-card h-100 rounded-2 p-3"
              style={{ '--air-quality-category-color': categoryColor }}
            >
              <div className="air-quality-report-card-header d-flex align-items-start justify-content-between gap-2">
                <h3 className="air-quality-report-title mb-0">{report.title}</h3>
                <span className="air-quality-report-category" title={categoryLabel}>
                  <PiWavesBold className="air-quality-report-category-icon" aria-hidden />
                  <span>{categoryLabel}</span>
                </span>
              </div>
              <dl className="air-quality-report-details mb-0">
                <div className="air-quality-report-detail">
                  <dt>Concentration</dt>
                  <dd>{report.concentration ?? '--'} ppb</dd>
                </div>
                {report.description && (
                  <div className="air-quality-report-detail air-quality-report-summary">
                    <dt>Summary</dt>
                    <dd>{report.description}</dd>
                  </div>
                )}
              </dl>
            </article>
          </li>
        );
      })}
    </ul>
  );
};

export default AirQualityReportList;
